import { TransitionGroup, CSSTransition } from 'react-transition-group'
import React, { useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

// Polyfill for findDOMNode since it was removed in React 19
// react-transition-group v4 still tries to use it as a fallback
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (node) => {
    // If it's already a DOM node, return it
    if (node instanceof Element) {
      return node
    }
    // If it's a ref object with current property
    if (node && node.current) {
      return node.current
    }
    // Otherwise return null
    return null
  }
}

// Wrapper to provide backward compatibility with react-addons-css-transition-group API
// while using the modern react-transition-group library
//
const ReactCSSTransitionGroup = ({ children, transitionName, transitionEnterTimeout, transitionLeaveTimeout, ...props }) => {
  const timeout = window.testMode ?
    1 :
    (transitionEnterTimeout || transitionLeaveTimeout || 500)

  return (
    <TransitionGroup {...props}>
      {React.Children.map(children, (child) =>
        child ?
          (
            <CSSTransitionWrapper
              key={child.key}
              timeout={timeout}
              classNames={transitionName}
            >
              {child}
            </CSSTransitionWrapper>
          ) :
          null
      )}
    </TransitionGroup>
  )
}

// Wrapper component to provide nodeRef for React 19 compatibility
const CSSTransitionWrapper = ({ children, ...props }) => {
  const nodeRef = useRef(null)

  return (
    <CSSTransition nodeRef={nodeRef} {...props}>
      <span ref={nodeRef} style={{ display: 'contents' }}>
        {children}
      </span>
    </CSSTransition>
  )
}

CSSTransitionWrapper.propTypes = {
  children: PropTypes.element.isRequired
}

ReactCSSTransitionGroup.propTypes = {
  children: PropTypes.node,
  transitionName: PropTypes.string,
  transitionEnterTimeout: PropTypes.number,
  transitionLeaveTimeout: PropTypes.number
}

// eslint-disable-next-line no-restricted-exports
export default ReactCSSTransitionGroup
